import OpenFileModalContainer from "components/OpenFileModal/OpenFileModalContainer";

export default OpenFileModalContainer;